import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, ArrowRight, Clock } from 'lucide-react';
import { blogPosts } from '../data/blogPosts';
interface Props {
  onBack: () => void;
  onSelectPost: (slug: string) => void;
}
export function BlogListPage({
  onBack,
  onSelectPost
}: Props) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <section className="min-h-screen bg-[#020611] pt-32 pb-24" data-id="element-28">
      <div className="container mx-auto px-6" data-id="element-29">
        <motion.button onClick={onBack} initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} className="inline-flex items-center gap-2 text-muted hover:text-accent transition-colors mb-12 group" data-id="element-30">
          <ArrowLeft size={18} className="group-hover:-translate-x-1 transition-transform" data-id="element-31" />
          Zurück zur Startseite
        </motion.button>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="mb-16" data-id="element-32">
          <div className="w-12 h-1 bg-accent mb-6" data-id="element-33" />
          <h1 className="text-3xl md:text-5xl font-heading font-bold" data-id="element-34">
            Alle Artikel
          </h1>
          <p className="text-muted mt-4 text-lg max-w-2xl" data-id="element-35">
            Praxiswissen, ehrliche Analysen und strategische Perspektiven rund
            um KI-Umsetzung in deutschen Unternehmen.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-36">
          {blogPosts.map((post, index) => <motion.article key={post.slug} initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} onClick={() => onSelectPost(post.slug)} className="group cursor-pointer" data-id="element-37">
              <div className="bg-surface border border-border p-8 h-full flex flex-col transition-all duration-300 group-hover:-translate-y-2 group-hover:border-accent/50 group-hover:shadow-[0_10px_30px_rgba(0,0,0,0.5)]" data-id="element-38">
                <div className="flex items-center gap-4 text-xs text-muted mb-6 font-mono" data-id="element-39">
                  <span data-id="element-40">{post.date}</span>
                  <span className="w-1 h-1 rounded-full bg-border" data-id="element-41" />
                  <span className="flex items-center gap-1" data-id="element-42">
                    <Clock size={12} data-id="element-43" />
                    {post.readTime}
                  </span>
                </div>
                <h3 className="text-xl font-heading font-semibold mb-4 group-hover:text-accent transition-colors leading-snug" data-id="element-44">
                  {post.title}
                </h3>
                <p className="text-muted text-sm leading-relaxed mb-8 flex-grow" data-id="element-45">
                  {post.excerpt}
                </p>
                <div className="mt-auto flex items-center gap-2 text-sm font-medium text-foreground group-hover:text-accent transition-colors" data-id="element-46">
                  Artikel lesen
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" data-id="element-47" />
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}